export const visit = (vm, at) => {
vm(require("foundations-components/lang/hr.lyaml"));
at({ "hr": { "placeholder": "rezervirano mjesto" } });
};